export const defaultDay = "mon";
export const defaultHour = 8;
